<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="BillingListView"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcBillingList
    class="page--grid"
  >
  </UcBillingList>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "billingList",
    path: "/billing-list",
    component: "BillingListView"
  }
)

@Component()
export default class BillingListView extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  messages!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['messages', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          title: this.$fn.pgettext("billingList|Title", "Billing list"),
        }
        ,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.messages.title,
        icon: this.$config.billingList.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_2076_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_2076, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_2076: actions.CloseModalAction;
    evh_7315092382398562_close_2075: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_2076 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_2076_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_2075 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_2076,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_2075],
      }
    );
    return {
      act_7315092382398562_closeModal_2076,
      evh_7315092382398562_close_2075,
      evh_7315092382398562_close,
    }
  }
}

Vue.component("BillingListView", BillingListView);

</script>